<template>
    <div class="card">
      <div class="card-body">
        <div v-if="$root.getLoggedUser() && $root.getLoggedUser().subscriptionEndDate">
          <div v-if="$root.getLoggedUser().isSubscriptionExpired">
            <span class="text-danger">Η συνδρομή σας έληξε {{ new Date($root.getLoggedUser().subscriptionEndDate).toLocaleDateString('el-GR') }}</span>
            <router-link class="ml-2" v-if="this.$route.name!=='plans'" :to="{path: '/plans'}"><u>ανανέωση</u></router-link>
          </div>
          <div v-else>
            <span v-if="$root.getLoggedUser().subscriptionExpiresSoon">
              <span class="text-danger">Η συνδρομή σας λήγει σύντομα: {{ new Date($root.getLoggedUser().subscriptionEndDate).toLocaleDateString('el-GR') }}</span>
              <router-link class="ml-2" v-if="this.$route.name!=='plans'" :to="{path: '/plans'}"><u>ανανέωση</u></router-link>
            </span>
            <span v-else class="text-success">Έχετε ενεργή συνδρομή έως: {{ new Date($root.getLoggedUser().subscriptionEndDate).toLocaleDateString('el-GR') }}</span>
          </div>
        </div>
        <div v-else>
            <span>Δεν έχετε ενεργή συνδρομή</span>
            <router-link class="ml-2" v-if="this.$route.name!=='plans'" :to="{path: '/plans'}"><u>απόκτηση συνδρομής</u></router-link>
        </div>
        <div v-if="$root.getLoggedUser() && $root.getLoggedUser().parent" class="text-muted mt-1">
          Γονικός λογαριασμός: {{ $root.getLoggedUser().parent.email }}
        </div>
        <div v-if="$root.getLoggedUser() && childrenCount > 0" class="text-muted mt-1">
          <div v-if="childrenEmails.length > 0">
            <div>
              <span @click="showChildrenEmails = !showChildrenEmails" title="Προβολή" style="cursor:pointer;">Πλήθος υπολογαριασμών: {{ childrenCount }}</span>
            </div>
            <div v-show="showChildrenEmails">
                <ul style="max-height:300px;overflow-y:auto;">
                  <li v-for="(childEmail,index) in childrenEmails" :key="index">{{ childEmail }}</li>
                </ul>
            </div>
          </div>
          <div v-else>
            <span>Πλήθος υπολογαριασμών: {{ childrenCount }}</span>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'subscription-end-date-card',
  props: {
    childrenCount: {
      type: Number
    },
    childrenEmails: {
      type: Array,
    },
  },
  components: {
    
  },
  data() {
    return {
      showChildrenEmails: false
    };
  },
  methods: {
    
  },
  mounted() {
    
  }
};
</script>
<style>
</style>
